export enum TipoParceriaComercialEnum {
  Seguradora = 1,
  Associacao = 2,
  Rede = 3,
  Sindicato = 4,
  Outro = 99,
}

export enum StatusConviteParceriaEnum {
  Pendente = 1,
  Usado = 2,
  Expirado = 3,
  Revogado = 4,
}

export interface CriarParceriaComercialRequest {
  nome: string;
  cnpjEmpresa: string;
  emailContato: string;
  telefoneContato: string;
  tipoParceria: TipoParceriaComercialEnum;
  quantidadeLicencasContratadas: number;
  dataInicioContrato: string;
  dataFimContrato: string;
  // White Label — criado/atualizado junto com a parceria
  whiteLabelSlug: string;
  whiteLabelNomeExibicao: string;
  whiteLabelLogoLoginArquivoId: number;
  whiteLabelLogoMenuArquivoId: number;
}

export interface AtualizarParceriaComercialRequest extends CriarParceriaComercialRequest {}

export interface CancelarParceriaComercialRequest {
  motivo: string;
}

export interface ParceriaComercialResponse {
  id: number;
  nome: string;
  cnpjEmpresa: string;
  emailContato: string;
  telefoneContato: string;
  tipoParceria: TipoParceriaComercialEnum;
  tipoParceriaDescricao: string;
  whiteLabelId?: number;
  whiteLabelNome?: string;
  whiteLabelSlug?: string;
  whiteLabelNomeExibicao?: string;
  whiteLabelLogoLoginArquivoId?: number;
  whiteLabelLogoMenuArquivoId?: number;
  whiteLabelLogoLoginUrl?: string;
  whiteLabelLogoMenuUrl?: string;
  quantidadeLicencasContratadas: number;
  quantidadeLicencasUtilizadas: number;
  quantidadeLicencasDisponiveis: number;
  dataInicioContrato: string;
  dataFimContrato: string;
  diasRestantes: number;
  contratoVigente: boolean;
  dataCancelamento?: string;
  motivoCancelamento?: string;
  ativoFlag: boolean;
  dataCadastro: string;
}

export interface CancelarParceriaComercialResponse {
  sucesso: boolean;
  mensagem: string;
  imobiliariasAfetadas: number;
  convitesRevogados: number;
}

export interface EmitirConviteParceriaRequest {
  parceriaComercialId: number;
  cnpjImobiliariaAlvo: string;
  nomeImobiliariaAlvo: string;
  emailContato: string;
  nomeContato: string;
}

export interface ConviteParceriaResponse {
  id: number;
  parceriaComercialId: number;
  parceriaNome: string;
  cnpjImobiliariaAlvo: string;
  nomeImobiliariaAlvo: string;
  emailContato: string;
  nomeContato: string;
  token: string;
  linkConvite: string;
  expiraEm: string;
  status: StatusConviteParceriaEnum;
  statusDescricao: string;
  imobiliariaConvertidaId?: number;
  dataUso?: string;
  dataCadastro: string;
}

export interface FinalizarCadastroParceriaRequest {
  token: string;
  cnpjImobiliaria: string;
  nomeFantasia: string;
  razaoSocial: string;
  emailImobiliaria: string;
  telefoneImobiliaria: string;
  cep: string;
  endereco: string;
  numero: string;
  complemento?: string;
  bairro: string;
  cidade: string;
  estado: string;
  nomeAdmin: string;
  cpfAdmin: string;
  emailAdmin: string;
  telefoneAdmin: string;
  senha: string;
}

export interface FinalizarCadastroParceriaResponse {
  sucesso: boolean;
  mensagem: string;
  imobiliariaCriadaId?: number;
  usuarioAdmId?: number;
}

export interface ValidarTokenConviteResponse {
  valido: boolean;
  mensagem: string;
  parceriaComercialId?: number;
  parceriaNome?: string;
  cnpjImobiliariaAlvo?: string;
  nomeImobiliariaAlvo?: string;
  emailContato?: string;
  nomeContato?: string;
  expiraEm?: string;
  whiteLabelSlug?: string;
  whiteLabelNomeExibicao?: string;
}
